import { Elements } from '@stripe/react-stripe-js'
import React from 'react'
import SubscriptionPending from './SubscriptionPending'
import { CircularProgressContinuous } from '@/components/loaders/CircularProgressContinuous'
import { loadStripe } from '@stripe/stripe-js'

// loadStripe should be called outside the components render to avoid recreating the stripe instance on every render
const stripePromise = loadStripe(import.meta.env.VITE_PUBLISHABLE_STRIPE_KEY)

const SubscriptionPendingContainer: React.FC = () => {
  const clientSecret = new URLSearchParams(window.location.search).get('setup_intent_client_secret')

  const appearance = {
    theme: 'stripe' as const,
    variables: {
      colorPrimary: '#2A49FF',
      colorBackground: '#fff',
      colorText: '#374151',
      colorDanger: '#b91c1c',
      fontFamily: '"DM Sans", ui-sans-serif, system-ui, sans-serif',
    },
  }

  const options = {
    clientSecret: clientSecret || undefined,
    appearance,
    fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400..700;1,400..700&display=swap' }],
  }

  if (!clientSecret) {
    return <CircularProgressContinuous />
  }

  return (
    <Elements options={options} stripe={stripePromise}>
      <SubscriptionPending />
    </Elements>
  )
}

export default SubscriptionPendingContainer
